module.exports = __webpack_public_path__ + "static/media/4.26335397.svg";